import { Button } from '@/components/ui-kit/button';
import { AlertTriangle, ArrowLeft, Compass } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <div className="relative min-h-screen overflow-hidden bg-background">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,hsl(var(--brand-surface-strong))_0%,hsl(var(--background))_58%)]" />
      <div className="pointer-events-none absolute -top-20 -right-20 h-72 w-72 rounded-full bg-[hsl(var(--selise-blue))]/15 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -left-12 h-80 w-80 rounded-full bg-[hsl(var(--sky-blue))]/10 blur-3xl" />

      <main className="relative z-10 mx-auto flex min-h-screen w-full max-w-5xl items-center px-4 py-10 sm:px-6 lg:px-8">
        <section className="w-full rounded-2xl border border-brand-border bg-card/90 p-6 shadow-[0_20px_60px_-30px_hsl(var(--oxford-blue))] backdrop-blur-sm sm:p-10 flex flex-col items-center justify-center text-center">
          <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-brand-border bg-brand-surface px-4 py-1.5 text-sm font-semibold text-brand-muted">
            <AlertTriangle className="h-4 w-4" />
            <span>{t('NOTFOUND_BADGE', 'Route Missing')}</span>
          </div>

          <p className="font-subheading text-sm font-semibold tracking-[0.18em] text-brand-muted">
            404
          </p>

          <h1 className="mt-3 max-w-2xl font-heading text-3xl font-bold leading-tight text-[hsl(var(--fg))] sm:text-5xl">
            {t('NOTFOUND_TITLE', 'This page does not exist in your workspace.')}
          </h1>

          <p className="mt-4 max-w-2xl text-base text-globe-grey-dark sm:text-lg">
            {t(
              'NOTFOUND_DESCRIPTION',
              'The link may be outdated, moved, or typed incorrectly. Use one of the actions below to continue working.'
            )}
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Button asChild variant="primary" size="lg" className="sm:min-w-52">
              <Link to="/onboarding">
                <Compass className="h-4 w-4" />
                {t('NOTFOUND_PRIMARY', 'Go to Onboarding')}
              </Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="sm:min-w-52">
              <Link to="/org/select">
                <ArrowLeft className="h-4 w-4" />
                {t('NOTFOUND_SECONDARY', 'Select Organization')}
              </Link>
            </Button>
          </div>

          <div className="mt-8 rounded-xl border border-brand-border bg-brand-surface px-4 py-3 text-sm text-[hsl(var(--globe-grey-500))] text-center w-full">
            {t(
              'NOTFOUND_HELP',
              'If you reached this page from a bookmark, update it with a valid route.'
            )}
          </div>
        </section>
      </main>
    </div>
  );
};

export default NotFoundPage;
